export { default, meta } from "./routes/signup.tsx";